module.exports = __webpack_public_path__ + "img/nfst.6bed0274.png";